import React from 'react';
import PropTypes from 'prop-types';

const STRUCTURE_OPTIONS = [
  {
    value: 'System User',
    title: 'System + User Messages',
    description: 'Best for role-based prompts. System defines role, User provides input.',
  },
  {
    value: 'User Only',
    title: 'User Message Only',
    description: 'Best for simple, direct prompts. Single instruction without system context.',
  },
  {
    value: 'System  User  Assistant ',
    title: 'System + User + Few-Shot Examples',
    description: 'Best for learning from examples. Show format through demonstrations.',
  },
];

const StepStructure = ({ formData, updateFormData, errors }) => {
  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>Choose your prompt structure</h3>
        <p>Select how your prompt messages should be organized.</p>
      </div>

      {errors?.type && (
        <div className="form-error-message">{errors.type}</div>
      )}

      <div className="radio-group">
        {STRUCTURE_OPTIONS.map((option) => (
          <label 
            key={option.value} 
            className={`radio-card ${formData.type === option.value ? 'selected' : ''}`}
          >
            <input
              type="radio"
              name="structure"
              value={option.value}
              checked={formData.type === option.value}
              onChange={(e) => updateFormData('type', e.target.value)}
            />
            <div className="radio-content">
              <span className="radio-title">{option.title}</span>
              <span className="radio-description">{option.description}</span>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

StepStructure.propTypes = {
  formData: PropTypes.shape({
    type: PropTypes.string,
  }).isRequired,
  updateFormData: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

StepStructure.defaultProps = {
  errors: {},
};

export default StepStructure;
